export default __webpack_public_path__ + "static/media/Primer-Red.a7136553.jpg";